<script setup lang="ts">
const localePath = useLocalePath()
const { t } = useI18n()

defineI18nRoute({
  paths: {
    'en-CA': '/investor-relations/shareholder-information/faq',
    'fr-CA': '/relations-avec-investisseurs/section-investisseurs/faq'
  }
})

useHead({
  title: t('navigation.faq.metatitle'),
  meta: [{ name: 'description', content: t('navigation.faq.metadescription') }]
})

</script>

<template>
  <div class="wrapContent">
    <div class="entetePage">
      <div class="wrapper">
        <div class="filAriane">
          <span class="">
            <NuxtLink :to="localePath('index')">{{ $t('navigation.home.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <NuxtLink :to="localePath('investorRelations-investorRelations')">{{ $t('navigation.investorRelations.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <NuxtLink :to="localePath('investorRelations-shareholderInformation')">{{ $t('navigation.shareholderInformation.name') }}</NuxtLink>
            <span class=""> &gt; </span>
            <span class="">{{ $t('navigation.faq.name') }}</span>
          </span>
        </div>
        <div class="title">
          <h1><span class="">{{ $t('navigation.faq.name') }}</span></h1>
        </div>
      </div>
    </div>
    <div class="contentPage">
      <div class="wrapper clearfix">
        <MenuInvestorRelations />
        <div class="contenu right">
          <div v-if="$i18n.locale == 'en-CA'"
               class="">
            <h2>Where do KP Tissue's common shares trade?</h2>
            <p>Common shares of KP Tissue trade on the Toronto Stock Exchange (TSX) under the stock symbol&nbsp;"KPT".</p>
            <h2>How can I purchase shares of KP Tissue?</h2>
            <p>Common shares of KP Tissue can be purchased through a broker or financial institution that deals TSX-listed securities.</p>
            <h2>When is KP Tissue 's fiscal year end?</h2>
            <p>The 12-month accounting period or fiscal year for KP Tissue ends December 31st.</p>
            <h2>How can I obtain copies of the company's financial documents?</h2>
            <p>
Quarterly and annual filings will be posted on this website in the Financial Documents section. Also, investors can access regulatory filings on SEDAR+ page at <a href="https://www.sedarplus.ca/"
                 target="_blank">www.sedarplus.ca</a>.
</p>
            <h2>How can I be notified of the company's financial filings and other important events?</h2>
            <p>You can register to automatically receive email alerts of filings and other important events on the Email Alerts section of this website.</p>
          </div>
          <div v-if="$i18n.locale == 'fr-CA'"
               class="">
            <h2>Où les actions ordinaires de Papiers Tissu KP se négocient-elles?</h2>
            <p>Elles se négocient à la Bourse de Toronto (TSX) sous le symbole boursier « KPT ».</p>
            <h2>Comment peut-on acheter des actions de Papiers Tissu KP?</h2>
            <p>En passant par un courtier ou une institution financière qui négocie des titres inscrits à la cote de la TSX.</p>
            <h2>Quand l’exercice financier de Papiers Tissu KP se termine-t-il?</h2>
            <p>L’exercice comptable de 12 mois (l’exercice financier) de Papiers Tissu KP se termine le 31 décembre.</p>
            <h2>Comment peut-on obtenir une copie des documents financiers de Papiers Tissu KP?</h2>
            <p>
Les rapports trimestriels et annuels sont publiés sur ce site Web, dans la section « Documents financiers ». De plus, les investisseurs peuvent obtenir les documents publics sur le site SEDAR+, à l’adresse <a href="https://www.sedarplus.ca/landingpage/fr/"
                 target="_blank">www.sedarplus.ca</a>.
</p>
            <h2>Comment peut-on être avisé des documents déposés par l’entreprise et d’autres événements importants?</h2>
            <p>Dans la page « Alertes par courriel » de ce site Web, il est possible de s’inscrire aux alertes envoyées automatiquement par courriel lors du dépôt de documents ou des événements importants de Papiers Tissu KP.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
